import { Question } from "../../../../utils/interface/exam";
import DataRenderer from "../../../render";

interface SubQuestionProps {
    question: Question;
}

export default function SubQuestion(props: SubQuestionProps) {

    const { question } = props;

    return (

        <div className="mcq-options" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%', marginTop: 20 }}>
            {/* <h3 style={{ fontWeight: 'bold',textDecoration:'underline' }}>Answer the following - </h3> */}
            {question.sub_question && question.sub_question.map((sub, index) => (
                <div style={{ marginBottom: 10 }} key={index}>
                    {
                        sub.is_question_alternative &&
                        <>
                            <span className="question_choice_text">OR</span>
                        </>
                    }

                    <span style={{ marginRight: '10px', fontSize: 16, display: 'flex' }}>
                        <span style={{ fontWeight: 'bold', marginRight: 5 }}>{sub.sub_question_number})</span>
                        <DataRenderer text={sub.question_text} type='mathpix' />
                    </span>
                    {
                        sub.options && sub.options.length > 0 &&
                        <ol type={'A'} className="mcq-options" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
                            {
                                sub.options.map((op, index) => (
                                    <li style={{ marginRight: '10px', fontSize: 16, marginBottom: 10, display: 'flex' }} key={index}>
                                        <span style={{ marginRight: 5 }}></span>
                                        <DataRenderer text={`${op.text}`} type='mathpix' />
                                    </li>))
                            }
                        </ol>
                    }
                    {
                        sub.data &&
                        sub.data.type === 'image' &&
                        <div className="question_data">
                            <img src={sub.data.value} alt="Question" />
                        </div>
                    }
                </div>
            ))
            }
        </div>


    )
}